import React, { useCallback, useEffect } from 'react';
import { enqueueSnackbar, closeSnackbar, SnackbarKey } from 'notistack';
import { useIntl } from 'react-intl';
import { ColorButton } from '@fuww/library/src/Button';
import messages from '../lib/messages.json';

interface UpdateMessageEvent extends MessageEvent {
  data: {
    type: string;
  };
}

const ServiceWorkerUpdateListener = () => {
  const intl = useIntl();

  const refreshAction = useCallback((key: SnackbarKey) => (
    <ColorButton
      name="update"
      variant="contained"
      onClick={() => {
        closeSnackbar(key);
        window.location.reload();
      }}
    >
      {intl.formatMessage(messages.refresh)}
    </ColorButton>
  ), [intl]);

  useEffect(() => {
    const handleServiceWorkerUpdate = (event: UpdateMessageEvent) => {
      if (event.data.type === 'UPDATE_AVAILABLE') {
        enqueueSnackbar(
          intl.formatMessage(messages.updateAvailable),
          {
            variant: 'info',
            persist: true,
            preventDuplicate: true,
            action: refreshAction,
          },
        );
      }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener(
        'message', handleServiceWorkerUpdate,
      );
    }

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener(
          'message',
          handleServiceWorkerUpdate,
        );
      }
    };
  }, [intl, refreshAction]);

  return null;
};

export default ServiceWorkerUpdateListener;
